import { z } from 'zod';
import { route, defineContract } from '../core/types';
import { requiredStringSchema, projectIdParamsSchema } from '../schemas';

// ============================================================
// Query Schemas
// ============================================================

const activeTimeVsTotalTimeQuerySchema = z.object({
	startDate: requiredStringSchema,
	endDate: requiredStringSchema,
	timezone: requiredStringSchema,
});

// ============================================================
// Contract
// ============================================================

/**
 * `{ root: true }` is new here, and it is the file's only real hazard:
 * `defineContract('analysis', …)` without it prefixes every path with the
 * contract name, which is where `/api/reports/analysis/…` came from. Going root
 * drops that prefix from EVERY route in the file, so the `analysis` segment is
 * now spelled explicitly in the path below — otherwise the URL would have moved
 * twice over. There is exactly one route here, and its literal absolute URL is
 * asserted in `analysis.routes.test.ts`.
 */
export const analysisContract = defineContract(
	'analysis',
	{
		getActiveTimeVsTotalTimeOnSite: route({
			method: 'GET',
			path: '/projects/:projectId/analysis/activeTimeVsTotalTimeOnSite',
			params: projectIdParamsSchema,
			query: activeTimeVsTotalTimeQuerySchema,
			response: z.any(),
			operationId: 'getActiveTimeVsTotalTimeOnSite',
			tags: ['Analysis'],
			summary: 'Get active time vs total time on site analysis',
		}),
	},
	{ root: true }
);
